import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-medium text-xl" }
const _hoisted_2 = { class: "text-center" }

import { onMounted, computed } from 'vue';
import constants from '@/utilities/constants';
import { useStore } from 'vuex';
import NoResource from '@/components/widgets/NoResource';
import onPageLoad from '@/utilities/composables/useOnPageLoad';
import Badge from '@/components/elements/Badge';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaidFeaturePaywall',
  props: {
    title: {},
    description: {},
    backgroundImageUrl: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const backgroundImageStyle = computed(() => {
  if (!props.backgroundImageUrl) return { background: 'var(--backgroundStrongest)' };

  return {
    backgroundImage: `url(${props.backgroundImageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
});

const openUpgradePlan = () => {
  store.dispatch('setShowUpgradePlanPopup', constants.featureFlagIds.roadmapAndProjects);
};

onMounted(() => {
  onPageLoad();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "paid-feature-paywall-wrapper",
    style: _normalizeStyle(backgroundImageStyle.value)
  }, [
    _createVNode(_unref(NoResource), null, {
      header: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(props.title), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(props.description), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(Badge), {
          class: "upgrade-plan-button",
          text: 'upgradePlan',
          onClick: openUpgradePlan
        })
      ]),
      _: 1
    })
  ], 4))
}
}

})